import Image from "next/image";
import logo from "@/assets/oem_transparent.png"
import { SmartLink } from "@/components/ui";
import { MenuSegments } from "./menu-segments";

export function Menu({ user }: { user: { name: string } | null }) {
    return (
        <div className="gap-6 items-center hidden md:flex">
            <SmartLink type="external" route="home" className="hidden md:flex">
                <Image priority src={logo} alt="Logo O&M" width={640} height={429} className="h-14 w-auto" unoptimized={true} />
            </SmartLink>
            <SmartLink type={"external"} route={"home"} className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                Home
            </SmartLink>

            <MenuSegments />

            <SmartLink type={"external"} route={"blog"} className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                Blog
            </SmartLink>

            <SmartLink type={"external"} route={"products"} className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                Produtos
            </SmartLink>

            <SmartLink type={"external"} route={"business"} className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                Empresa
            </SmartLink>

            {user
                ? <SmartLink type={"internal"} route={"home"} className="flex gap-2 items-center hover:scale-105 hover:text-dark_accent dark:hover:text-light_accent">
                    Sistema
                </SmartLink>
                : ''}
        </div>
    )
}